import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import TimePicker from 'modules/core/components/Inputs/TimePicker'
import i18n from 'modules/core/lib/i18n'

import useIsTimeFormat24H from 'modules/shift_management/hooks/useIsTimeFormat24H'

import TooltipIcon from './TooltipIcon'

interface Props {
  startField: Field
  endField: Field
  mixedValues?: boolean
  newVersion?: boolean
}

const ShiftTimePicker = ({ startField, endField, mixedValues, newVersion = false }: Props) => {
  const placeholder = mixedValues ? i18n.t('shift_management.edit_shifts.placeholder') : ''
  const { isTimeFormat24H } = useIsTimeFormat24H()
  const startFieldErrors = startField.errors || []
  const endFieldErrors = endField.errors || []
  const error = startFieldErrors[0] || endFieldErrors[0] || undefined

  const isMultiDayShift = (): boolean => {
    const startTime = startField.value
    const endTime = endField.value

    return endTime <= startTime && endTime && startTime
  }

  return (
    <Box gap="s4" className={error && 'error-anchor'}>
      <Box flexDirection="row" gap="s8">
        <Box flexDirection="row" gap="s16" justifyContent="center" alignItems="center">
          {newVersion && (
            <TooltipIcon.Medium
              icon="clock"
              label={i18n.t('shift_management.actions_sidepanel.tooltip.time_period')}
              color="grey700"
            />
          )}
          <TimePicker
            label={newVersion ? undefined : i18n.t('shift_management.add_shift.start')}
            field={startField}
            isTimeFormat24H={isTimeFormat24H}
            placeholder={placeholder}
            onBlur={() => startField.setErrors([])}
            isNotValid={!!error}
            hideError
          />
          <TimePicker
            label={newVersion ? undefined : i18n.t('shift_management.add_shift.end')}
            field={endField}
            isTimeFormat24H={isTimeFormat24H}
            placeholder={placeholder}
            onBlur={() => endField.setErrors([])}
            autofocus={!!error}
            isNotValid={!!error}
            hideError
          />
        </Box>
        {isMultiDayShift() && (
          <Box alignItems="center" flexDirection="row" paddingTop={newVersion ? undefined : 's24'}>
            <Tag type={Tag.Types.grey}>{i18n.t('shift_management.plus_1_day_tag')}</Tag>
          </Box>
        )}
      </Box>

      {error && (
        <Box paddingLeft="s40" alignItems="flexStart">
          <Text size="200" color="radicalRed1000" capitalize>
            {error}
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default observer(ShiftTimePicker)
